var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"color":"rgba(255,0,0,0)"}},[_c('div',{staticClass:"embed-container embed-containervideo"},[_c('youtube',{staticClass:"embed-container2",attrs:{"video-id":_vm.videoId,"player-width":"1080","player-height":"720","player-vars":{ autoplay: 1 }},on:{"playing":_vm.playing,"ended":_vm.ended,"paused":_vm.paused}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ef29b64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stream_video_components/player.vue
// module id = null
// module chunks = 